import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
@Component({
  selector: 'jsg-hearing-date-view',
  templateUrl: './hearing-date-view.component.html',
  styleUrls: ['./hearing-date-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HearingDateViewComponent implements OnInit {
  @Input() isUrgent: boolean = false;
  @Input() showJusticePrefix: boolean = false;
  @Input() hearingDate: Date;
  @Input() justiceName: string;
  @Input() hearingDuration: number;
  @Input() isAdjournedPending: boolean = false;
  @Input() isAdjournedSineDiePending: boolean = false;

  @Input() urgentTimeRequired: number;
  @Input() urgencyComments: string;
  @Input() urgencyDates: string;

  @Input() backgroundStyleClass: string;

  constructor() {}

  ngOnInit(): void {}

  public getEndTime(startTime: Date, duration: number) {
    startTime = new Date(startTime);
    let endDate = startTime;
    return endDate.setMinutes(startTime.getMinutes() + duration);
  }
}
